/** Device Capabilities */
export enum DeviceCapability {
  UNKNOWN = "UNKNOWN",
  TRANSMITTER = "TRANSMITTER",
  RECEIVER = "RECEIVER",
}

export enum DeviceClass {
  UNKNOWN = "UNKNOWN",
  ACCESSORY = "ACCESSORY",
  ACOUSTIC_RELEASE = "ACOUSTIC_RELEASE",
  BETA = "BETA",
  COMPONENT = "COMPONENT",
  DATALOGGER = "DATALOGGER",
  HUB = "HUB",
  RECEIVER = "RECEIVER",
  SENSOR = "SENSOR",
  TAG = "TAG",
}

export enum DeviceTagMode {
  INCREASED_RESIDENCY = "IR",
}

// The types below are minimal versions of the GQL types returned by the data-graph.
// They have just enough fields to resolve type errors in files that have already been
// converted to TypeScript. The main Devices component is still in plain JavaScript.
//
// In the future, when we move everything to TypeScript, we should share the generated
// TS types from the data-graph directly, rather than maintaining copies in this project.
// See animals-types.ts, which does this for Animal types, in a more complete way.

/** Represents a physical innovasea device */
export type Device = {
  /**  Device ID */
  id: string;
  /**  Events that involve this device. e.g. Deployments or offloads  */
  events: DeviceEvent[];
};

export type DeviceEvent = {
  id: string;
  date: string;
  notes?: string;
};
